/**
 * @generated SignedSource<<a23f07e35201bc857ab32cd625d77c83>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteIdleTimeInput = {
  id: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deleteIdleTimeMutation$variables = {
  input: DeleteIdleTimeInput;
};
export type deleteIdleTimeMutation$data = {
  readonly deleteIdleTime: {
    readonly deletedIdleTimeId: string | null;
  } | null;
};
export type deleteIdleTimeMutation = {
  variables: deleteIdleTimeMutation$variables;
  response: deleteIdleTimeMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteIdleTimePayload",
    "kind": "LinkedField",
    "name": "deleteIdleTime",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedIdleTimeId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteIdleTimeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteIdleTimeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "951b18ab6363c300c38c41c979e8337b",
    "id": null,
    "metadata": {},
    "name": "deleteIdleTimeMutation",
    "operationKind": "mutation",
    "text": "mutation deleteIdleTimeMutation(\n  $input: DeleteIdleTimeInput!\n) {\n  deleteIdleTime(input: $input) {\n    deletedIdleTimeId\n  }\n}\n"
  }
};
})();

(node as any).hash = "c64e28d1407937f0a1639e7765fedc79";

export default node;
